/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { LoadConfigOkResult } from './LoadConfigOkResult'
import {
  LoadConfigOkResultFromJSON,
  LoadConfigOkResultFromJSONTyped,
  LoadConfigOkResultToJSON,
} from './LoadConfigOkResult'
import type { ScaniaImportXmlResponseWrapperError } from './ScaniaImportXmlResponseWrapperError'
import {
  ScaniaImportXmlResponseWrapperErrorFromJSON,
  ScaniaImportXmlResponseWrapperErrorFromJSONTyped,
  ScaniaImportXmlResponseWrapperErrorToJSON,
} from './ScaniaImportXmlResponseWrapperError'

/**
 * This wrapper is needed to match the old API exactly diring the
 * migration, consider using different models and response codes for
 * success and error cases later.
 * @export
 * @interface ScaniaImportXmlResponseWrapper
 */
export interface ScaniaImportXmlResponseWrapper {
  /**
   *
   * @type {LoadConfigOkResult}
   * @memberof ScaniaImportXmlResponseWrapper
   */
  success?: LoadConfigOkResult | null
  /**
   *
   * @type {ScaniaImportXmlResponseWrapperError}
   * @memberof ScaniaImportXmlResponseWrapper
   */
  error?: ScaniaImportXmlResponseWrapperError | null
}

/**
 * Check if a given object implements the ScaniaImportXmlResponseWrapper interface.
 */
export function instanceOfScaniaImportXmlResponseWrapper(
  value: object,
): boolean {
  let isInstance = true

  return isInstance
}

export function ScaniaImportXmlResponseWrapperFromJSON(
  json: any,
): ScaniaImportXmlResponseWrapper {
  return ScaniaImportXmlResponseWrapperFromJSONTyped(json, false)
}

export function ScaniaImportXmlResponseWrapperFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ScaniaImportXmlResponseWrapper {
  if (json === undefined || json === null) {
    return json
  }
  return {
    success: !exists(json, 'success')
      ? undefined
      : LoadConfigOkResultFromJSON(json['success']),
    error: !exists(json, 'error')
      ? undefined
      : ScaniaImportXmlResponseWrapperErrorFromJSON(json['error']),
  }
}

export function ScaniaImportXmlResponseWrapperToJSON(
  value?: ScaniaImportXmlResponseWrapper | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    success: LoadConfigOkResultToJSON(value.success),
    error: ScaniaImportXmlResponseWrapperErrorToJSON(value.error),
  }
}
